import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'displayError' })
export class DisplayErrorPipe implements PipeTransform {
    transform(errorsObject: {}) {
        if (Object.values(errorsObject)[0]['message']) {
            return Object.values(errorsObject)[0]['message'];
        } else {
            return Object.keys(errorsObject)[0];
        }
    }
}
